(function () {
  'use strict';

  var CONFIG = {
    blockRightClick: true,
    blockImageDrag: true,
    blockTextSelection: true,
    blockCopy: true,

    allowInputs: true,

    protectedSelectors: [
      'img',
      '.product-single__description',
      '.product__description',
      '.rte',
      '.grid-product__title',
      '.grid-product__price',
      '.product-single__title',
      '.product__title'
    ]
  };

  function isEditableElement(el) {
    if (!el) return false;

    var tag = (el.tagName || '').toLowerCase();

    return (
      tag === 'input' ||
      tag === 'textarea' ||
      tag === 'select' ||
      tag === 'option' ||
      el.isContentEditable
    );
  }

  function matchesProtectedSelector(el) {
    if (!el || !el.closest) return false;

    for (var i = 0; i < CONFIG.protectedSelectors.length; i++) {
      if (el.closest(CONFIG.protectedSelectors[i])) {
        return true;
      }
    }

    return false;
  }

  function shouldBlockEvent(e) {
    var target = e.target;

    if (CONFIG.allowInputs && isEditableElement(target)) {
      return false;
    }

    return matchesProtectedSelector(target) || target === document || target === document.body;
  }

  if (CONFIG.blockRightClick) {
    document.addEventListener('contextmenu', function (e) {
      if (shouldBlockEvent(e)) {
        e.preventDefault();
        return false;
      }
    }, true);
  }

  if (CONFIG.blockImageDrag) {
    document.addEventListener('dragstart', function (e) {
      var target = e.target;

      if (target && target.tagName && target.tagName.toLowerCase() === 'img') {
        e.preventDefault();
        return false;
      }
    }, true);
  }

  if (CONFIG.blockCopy) {
    document.addEventListener('copy', function (e) {
      if (shouldBlockEvent(e)) {
        e.preventDefault();
        return false;
      }
    }, true);

    document.addEventListener('cut', function (e) {
      if (shouldBlockEvent(e)) {
        e.preventDefault();
        return false;
      }
    }, true);
  }

  if (CONFIG.blockTextSelection) {
    var css = [
      'img {',
      '  -webkit-user-drag: none !important;',
      '  user-drag: none !important;',
      '  pointer-events: auto;',
      '}',
      '.product-single__description,',
      '.product__description,',
      '.rte,',
      '.grid-product__title,',
      '.grid-product__price,',
      '.product-single__title,',
      '.product__title {',
      '  -webkit-user-select: none !important;',
      '  -moz-user-select: none !important;',
      '  -ms-user-select: none !important;',
      '  user-select: none !important;',
      '}',
      'input, textarea, select, option {',
      '  -webkit-user-select: text !important;',
      '  -moz-user-select: text !important;',
      '  -ms-user-select: text !important;',
      '  user-select: text !important;',
      '}'
    ].join('\n');

    var style = document.createElement('style');
    style.id = '__copy_protect_styles';
    style.appendChild(document.createTextNode(css));

    if (document.head) {
      document.head.appendChild(style);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        document.head.appendChild(style);
      });
    }
  }
})();